import React from "react";
const icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path d="M12 2.25C8.282 2.25 5.25 5.282 5.25 9c0 1.055.428 2.265 1.008 3.586.58 1.321 1.327 2.724 2.086 4.031a76.014 76.014 0 0 0 3.047 4.805l.609.89.61-.89s1.529-2.189 3.046-4.805c.759-1.307 1.506-2.71 2.086-4.031.58-1.321 1.008-2.531 1.008-3.586 0-3.718-3.032-6.75-6.75-6.75Zm0 1.5c2.91 0 5.25 2.34 5.25 5.25 0 .6-.322 1.737-.867 2.977-.545 1.239-1.298 2.613-2.04 3.89-1.177 2.033-1.91 3.109-2.343 3.75-.434-.641-1.166-1.717-2.344-3.75-.741-1.277-1.494-2.651-2.039-3.89C7.072 10.737 6.75 9.6 6.75 9c0-2.91 2.34-5.25 5.25-5.25Zm0 3.75a1.5 1.5 0 1 0 0 3 1.5 1.5 0 1 0 0-3Z" />
  </svg>
);

export default icon;
